import { useEffect } from 'react';
import tokenService from '../../services/tokenService';

// مكون لتجديد التوكن التلقائي
const AutoTokenRefresh = () => {
  useEffect(() => {
    // دالة لتجديد التوكن التلقائي
    const autoRefreshToken = async () => {
      try {
        const accessToken = tokenService.getAccessToken();
        
        if (accessToken) {
          // التحقق من الحاجة للتجديد
          if (tokenService.shouldRefreshToken(accessToken)) {
            console.log('Auto-refreshing token before expiry...');
            await tokenService.refreshAccessToken();
            console.log('Token auto-refreshed successfully');
          }
        }
      } catch (error) {
        console.error('Auto token refresh failed:', error);
        // في حالة فشل التجديد، لا نفعل شيئاً هنا
        // سيتم التعامل مع هذا في API interceptor
      }
    };

    // تجديد التوكن كل دقيقة للتحقق من الحاجة للتجديد
    const interval = setInterval(autoRefreshToken, 60000); // كل 60 ثانية

    // تجديد التوكن فوراً عند تحميل المكون
    autoRefreshToken();

    // تنظيف الـ interval عند إلغاء تحميل المكون
    return () => {
      clearInterval(interval);
    };
  }, []);

  // هذا المكون لا يعرض أي شيء
  return null;
};

export default AutoTokenRefresh;
